import UnitApi from '../../../api/masterData/unitApi';

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async fetch({dispatch}) {
      try {
        const response = await UnitApi.fetch();
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
